// src/pages/customerPendingRecord/CustomerPendingSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomerPendingList } from "./CustomerPendingThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    userId:null,
    locationId:null
  },
};

const customerPendingSlice = createSlice({
  name: "customerPending",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerPendingList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerPendingList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCustomerPendingList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = customerPendingSlice.actions;
export default customerPendingSlice.reducer;
